import React from "react";
import { Route, Routes } from "react-router-dom";
import config from "../config";
import FunderCheck from "../FunderCheck";
import Assets from "../AllAssets/Assets";
import AllAssets from "../AllAssets";
import Audits from "../Audits";
import Dashboard from "../Dashboard";
import DataCheck from "../Datacheck";
import Reports from "../Reports/Reports";
import Setup from "../System";
import Manage from "../Manage";
import Settings from "../Settings";
import Operations from "../Reports/Operations";
import NotFound from "../common/components/NotFound";
import { strings } from "../common/i18n";
import { useSyncUserLanguage } from "../common/hooks";
import AdminOnly from "../common/components/AdminOnly";

const paths = {
    allasset: `${config.paths.allasset}`,
    assets: `${config.paths.assets}`,
    audits: `${config.paths.audits}`,
    api: `${config.paths.api}`,
    dashboard: `${config.paths.dashboard}`,
    dataCheck: `${config.paths.dataCheck}`,
    funderCheck: `${config.paths.funderCheck}`,
    reports: `${config.paths.reports}`,
    manage: `${config.paths.manage}`,
    setup: `${config.paths.setup}`,
    settings: `${config.paths.settings}`,
    operations: `${config.paths.operations}`
};

/**
 * Auth Routes Component
 */
export default () => {
    useSyncUserLanguage();
    return (
        <Routes>
            <Route
                path="*"
                element={
                    <NotFound message={strings("messages.pageNotFound")} />
                }
            />
            <Route path="/" element={<Dashboard />} />
            <Route path={paths.dashboard} element={<Dashboard />} />
            <Route path={paths.assets} element={<Assets />} />
            <Route path={`${paths.allasset}/*`} element={<AllAssets />} />
            {/* <Route path={`${paths.dataCheck}/*`} element={<Datacheck />} /> */}
            {/* Admin-only. The nav hides Manage from Controllers, but the route
                was open by URL and let them create branches. */}
            <Route
                path={`${paths.manage}/*`}
                element={
                    <AdminOnly>
                        <Manage />
                    </AdminOnly>
                }
            />
            <Route path={`${paths.audits}/*`} element={<Audits />} />
            <Route path={`${paths.dataCheck}/*`} element={<DataCheck />} />
            <Route path={`${paths.funderCheck}/*`} element={<FunderCheck />} />
            <Route path={paths.reports} element={<Reports />} />
            <Route path={paths.operations} element={<Operations />} />
            <Route path={`${paths.setup}/*`} element={<Setup />} />
            <Route path={`${paths.settings}`} element={<Settings />} />
        </Routes>
    );
};
